import React, { memo } from 'react';
import './demandPlannerYoySec.scss';

const MskuGrowthDataTable = memo((props) => {

    const valueChecker = (value) => {
        if (value > 0) {
            return 'positive-value'
        }
        else if (value < 0) {
            return 'negative-value'
        }
        else {
            return 'zero-value'
        }
    }

    return (
        <table className='msku-info-table'>
            <thead>
                <tr>
                    <th colSpan={(props.data && props.data.Brands[0]?.MasterSkus[0]?.MasterSkuData.length)} className='header-bg-1 msku-cell fix-top-0'>{props.heading}</th>
                </tr>
                <tr>
                    {
                        props.data && props.data.Brands[0]?.MasterSkus[0]?.MasterSkuData.map((item, ind) => (
                            <th key={item.Year + ind} className='header-bg-2 msku-cell fix-top-24'>{item.Year}</th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    props.data && props.data.Brands.map((brand, index) => (
                        <React.Fragment key={'z' + index}>
                            {
                                Object.values(brand.MasterSkus.reduce((r, a) => {
                                    r[a.Format] = [...r[a.Format] || [], a];
                                    return r;
                                }, {}))
                                    .map(item => (
                                        item.map((msku, indx) => (
                                            <React.Fragment key={'y' + indx}>
                                                <tr key={'a' + indx} className='row-right-border'>
                                                    {
                                                        msku.MasterSkuData.map((elm, elmInd) => (
                                                            <td key={'a-a' + elmInd} className={`msku-cell msku-cell-bg-white ${valueChecker(elm[props.objKey])}`}>
                                                                {elm[props.objKey] || elm[props.objKey] === 0 ? `${elm[props.objKey]?.toFixed(2)}%` : ''}
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                                {
                                                    item.length - 1 === indx ?
                                                        (
                                                            <tr key={'b' + indx} className='highlight-row-bg-blue row-right-border'>
                                                                {
                                                                    brand.FormatData.filter(format => format.FormatName === msku.Format)
                                                                        .map(elm => (
                                                                            elm.Data.map((data, dataInd) => (
                                                                                <td key={'b-b' + dataInd} className={`msku-cell ${valueChecker(data[props.objKey])}`}>
                                                                                    {data[props.objKey] || data[props.objKey] === 0 ? `${data[props.objKey]?.toFixed(2)}%` : ''}
                                                                                </td>
                                                                            ))
                                                                        ))
                                                                }
                                                            </tr>
                                                        )
                                                        :
                                                        null
                                                }
                                            </React.Fragment>
                                        ))
                                    ))
                            }
                            {
                                brand.VariantData.map((variant, varInd) => (
                                    <tr key={'c' + varInd} className='highlight-row-bg-green row-right-border'>
                                        {
                                            variant.Data.map((elm, elmInd) => (
                                                <td key={'c-c' + elmInd} className={`msku-cell ${valueChecker(elm[props.objKey])}`}>
                                                    {elm[props.objKey] || elm[props.objKey] === 0 ? `${elm[props.objKey]?.toFixed(2)}%` : ''}
                                                </td>
                                            ))
                                        }
                                    </tr>
                                ))
                            }
                            <tr key={'d' + index} className='highlight-row-bg-grey row-right-border'>
                                {
                                    brand.BrandData.map((elm, elmInd) => (
                                        <td key={'d-d' + elmInd} className={`msku-cell ${valueChecker(elm[props.objKey])}`}>
                                            {elm[props.objKey] || elm[props.objKey] === 0 ? `${elm[props.objKey]?.toFixed(2)}%` : ''}
                                        </td>
                                    ))
                                }
                            </tr>
                        </React.Fragment>
                    ))
                }
                {
                    props.data && (
                        <tr className='highlight-row-bg-orange row-right-border'>
                            {
                                props.data.Category?.CategoryData.map((cat, ind) => (
                                    <td key={ind} className={`msku-cell ${valueChecker(cat[props.objKey])}`}>
                                        {cat[props.objKey] || cat[props.objKey] === 0 ? `${cat[props.objKey]?.toFixed(2)}%` : ''}
                                    </td>
                                ))
                            }
                        </tr>
                    )
                }
            </tbody>

        </table>
    );
})

export default MskuGrowthDataTable;